"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      height: 550,
      overflow: 'auto',
      display: 'flex',
      justifyContent: 'center'
    }
  };
});

var MarketplaceListWrapper = function MarketplaceListWrapper(_ref) {
  var children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": "CreateGift-MarketplaceListWrapper",
    p: 0.5,
    className: classes.root
  }, children());
};

MarketplaceListWrapper.propTypes = {
  children: _propTypes.default.func.isRequired
};
var _default = MarketplaceListWrapper;
exports.default = _default;